/**
 * talk·point — Kauf-Gate für 0-%-Artikel nach § 12 Abs. 3 UStG (IT#16795, v1: IT#16625).
 *
 * Gegenstück zu snippets/tp-pv-gate.liquid. Der Server rendert Kaufen-Button und
 * Warenkorb-Kasse bereits "disabled data-tp-pv-locked", den PayPal-Mount mit
 * "data-tp-pv-lock" (tp-paypal-lazy.js hebt gesperrte Mounts nicht ins DOM) und den
 * Wrapper mit "is-locked". Alles bleibt SICHTBAR — nur erkennbar gesperrt. Erst die
 * angekreuzte Checkbox (data-tp-pv-consent) entsperrt und aktiviert den Hidden-Input
 * mit der Line-Item-Property "Nullsteuersatz-Erklärung". Fail-closed: ohne JS kein Kauf.
 *
 * Der Sperr-Look hängt am disabled-Attribut bzw. an .is-locked, nicht an einer eigenen
 * JS-Klasse — fällt das Attribut, ist der Button in einem Rutsch wieder normal.
 *
 * Klick auf einen gesperrten Button: disabled-Buttons feuern keine Click-Events, und
 * pointer-events:none reicht den Klick ans Elternelement durch. Darum hängt der
 * Shake-Handler auf den umgebenden Zonen (bindZones) und reagiert nur, wenn das
 * Ereignis die Zone selbst trifft — ein Klick aufs Mengenfeld hat ein anderes target.
 *
 * Zwei Spuren für den Nachweis:
 *  - Line-Item-Property an der Position (führend, hängt an der Zeile) und
 *  - Cart-Attribut gleichen Namens an der Bestellung (POST /cart/update.js).
 * Ein PayPal-Direktkauf von der Produktseite legt einen eigenen Checkout ohne den
 * Warenkorb an und nimmt Cart-Attribute womöglich NICHT mit — dort trägt die
 * Line-Item-Property den Nachweis. Im Warenkorb bleibt ebenfalls die Zeilen-Property
 * das Kriterium (Property = Position, Attribut = Bestellung).
 *
 * Gegenüber dem v1-Asset entfallen: Varianten-Map und variant-change-Bindung (die
 * refurbished-PDP hat keine echten Varianten, der tp-Variantenselector redirectet auf
 * ein eigenes Produkt) sowie der Empire-fetch-Wrapper (Horizon postet FormData nativ).
 *
 * Bewusst import-frei (kein Modul) — gleiches Muster wie tp-condition-property.js.
 */
(function () {
  'use strict';
  if (window.__tpPvGateInit) return;
  window.__tpPvGateInit = true;

  var VERSION_FALLBACK = 'v1';
  var PROPERTY_NAME = 'Nullsteuersatz-Erklärung';
  /* Notbremse, falls /cart/update.js hängt: länger hält der submit-Guard den
     Add-to-Cart nicht zurück. */
  var ATTRIBUTE_TIMEOUT_MS = 1500;
  var OPEN_TEXT = 'Bestätigung erfasst. Der Kauf ist jetzt freigegeben.';

  function version(gate) {
    return gate.getAttribute('data-tp-pv-version') || VERSION_FALLBACK;
  }

  function stamp(gate) {
    return 'Bestätigt ' + version(gate) + ' · ' + new Date().toISOString();
  }

  function mode(gate) {
    return gate.getAttribute('data-tp-pv-mode') || 'product';
  }

  function isConsented(gate) {
    var box = gate.querySelector('[data-tp-pv-consent]');
    return !!(box && box.checked);
  }

  function say(gate, text) {
    var el = gate.querySelector('[data-tp-pv-status]');
    if (el) el.textContent = text;
  }

  function parseJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function postJson(url, payload) {
    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function shake(gate) {
    gate.classList.remove('is-shake');
    /* Reflow erzwingen, damit die Animation beim zweiten Versuch neu startet. */
    void gate.offsetWidth;
    gate.classList.add('is-shake');
    setTimeout(function () { gate.classList.remove('is-shake'); }, 600);
    var box = gate.querySelector('[data-tp-pv-consent]');
    if (box) { try { box.focus(); } catch (e) { /* älterer Browser */ } }
  }

  /* --------------------------------------------------------------- Sperre auf/zu */

  /**
   * Setzt den Sperrzustand für alles, was in scope zum Gate gehört.
   * Ein ausverkaufter Button (data-tp-pv-soldout) bleibt in jedem Fall gesperrt.
   */
  function applyLock(scope, open) {
    var btns = scope.querySelectorAll('[data-tp-pv-locked]');
    var i;
    for (i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var buyable = open && !btn.hasAttribute('data-tp-pv-soldout');
      if (buyable) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
      } else {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }
    }

    var express = scope.querySelectorAll('[data-tp-pv-express]');
    for (i = 0; i < express.length; i++) {
      if (open) {
        express[i].classList.remove('is-locked');
        express[i].removeAttribute('aria-disabled');
        /* Auf der PDP kommt der Express-Block ausgeblendet aus dem Server (es gäbe
           bis zum Mount nichts zu zeigen). Einmal eingeblendet bleibt er stehen:
           ein wieder abgewählter Consent sperrt ihn per is-locked, statt einen
           bereits gemounteten Button verschwinden zu lassen. */
        express[i].hidden = false;
      } else {
        express[i].classList.add('is-locked');
        express[i].setAttribute('aria-disabled', 'true');
      }
    }

    /* PayPal hängt am Lazy-Mount: gesperrt = gar nicht erst mounten (spart auf einer
       gesperrten Seite das komplette PayPal-SDK). Nach der Freigabe Mount nachholen. */
    if (open) {
      var locks = scope.querySelectorAll('[data-tp-pv-lock]');
      for (i = 0; i < locks.length; i++) locks[i].removeAttribute('data-tp-pv-lock');
      if (locks.length && window.tpPaypalMount) window.tpPaypalMount();
    }
  }

  /* ------------------------------------------------------------ Cart-Attribut */

  /* Setzt (oder räumt) das Cart-Attribut. Fire-and-forget: der Klick darf daran nie
     hängenbleiben. Solange der Request läuft, merkt sich das Gate den Zustand, damit
     der submit-Guard den Add-to-Cart kurz zurückhalten kann. */
  function sendAttribute(gate, value) {
    if (!window.fetch) return;

    var attributes = {};
    attributes[PROPERTY_NAME] = value;

    gate.tpPvAttrPending = true;
    var settled = false;

    function settle() {
      if (settled) return;
      settled = true;
      gate.tpPvAttrPending = false;
      var form = gate.tpPvResubmit;
      gate.tpPvResubmit = null;
      if (form) resubmit(form);
    }

    setTimeout(settle, ATTRIBUTE_TIMEOUT_MS);

    try {
      postJson('/cart/update.js', { attributes: attributes }).then(settle)['catch'](settle);
    } catch (e) {
      settle();
    }
  }

  /* Der Guard hat den Submit abgefangen, während das Attribut unterwegs war — jetzt
     nachholen. requestSubmit() löst denselben submit-Handler aus wie der Klick. */
  function resubmit(form) {
    setTimeout(function () {
      try {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      } catch (e) { /* dann klickt der Kunde eben erneut — der Button ist offen */ }
    }, 0);
  }

  /* ------------------------------------------------------------------ Produkt */

  function applyProduct(gate) {
    var form = gate.closest ? gate.closest('form') : null;
    if (!form) return;

    var consented = isConsented(gate);
    var prop = form.querySelector('[data-tp-pv-property]');
    if (prop) {
      if (consented) {
        prop.disabled = false;
        prop.value = stamp(gate);
      } else {
        prop.disabled = true;
        prop.value = '';
      }
    }

    applyLock(form, consented);

    var hint = gate.querySelector('[data-tp-pv-hint]');
    if (hint) {
      if (consented) hint.setAttribute('hidden', '');
      else hint.removeAttribute('hidden');
    }
    say(gate, consented ? OPEN_TEXT : '');

    /* Cart-Attribut zusätzlich zur Property — Wert aus dem Property-Input, damit
       beide Spuren denselben Zeitstempel tragen. Beim Abwählen wieder räumen
       (Shopify entfernt leere Attribute). */
    sendAttribute(gate, consented && prop ? prop.value : '');
  }

  /* ---------------------------------------------------------------- Warenkorb */

  /* Trägt die Bestätigung an allen betroffenen Zeilen nach. Adressiert wird über den
     Line-Item-Key (change.js akzeptiert ihn als id) — Zeilenindizes verschieben sich,
     sobald Shopify eine Zeile mit neuen Properties neu einsortiert. Bestehende
     Properties gehen mit, sonst verliert die Zeile z. B. "Zustand". Kein Reload:
     nach der letzten Antwort wird in-place entsperrt (im Drawer wäre ein Reload ein
     Bruch); die Bestätigungszeile an der Position erscheint beim nächsten Cart-Render. */
  function submitCart(gate) {
    var lines = parseJson(gate.querySelector('script[data-tp-pv-cart-lines]'));
    var box = gate.querySelector('[data-tp-pv-consent]');
    if (!lines || !lines.length || !window.fetch) return;

    if (box) box.disabled = true;
    gate.setAttribute('data-tp-pv-busy', '');

    var value = stamp(gate);
    var attributes = {};
    attributes[PROPERTY_NAME] = value;
    var i = 0;

    function fail() {
      if (box) { box.disabled = false; box.checked = false; }
      gate.removeAttribute('data-tp-pv-busy');
      shake(gate);
    }

    function finish() {
      gate.removeAttribute('data-tp-pv-busy');
      /* Alle Cart-Gates im Dokument öffnen: Warenkorb-Seite und Drawer können
         gleichzeitig im DOM stehen. */
      applyLock(document, true);
      var gates = document.querySelectorAll('[data-tp-pv-gate][data-tp-pv-mode="cart"]');
      for (var g = 0; g < gates.length; g++) {
        var other = gates[g];
        var otherBox = other.querySelector('[data-tp-pv-consent]');
        if (otherBox) { otherBox.checked = true; otherBox.disabled = false; }
        var hint = other.querySelector('[data-tp-pv-hint]');
        if (hint) hint.setAttribute('hidden', '');
        say(other, OPEN_TEXT);
      }
    }

    function next() {
      if (i >= lines.length) {
        /* Attribut ist die Kür — die Freigabe kommt in jedem Fall. */
        postJson('/cart/update.js', { attributes: attributes }).then(finish)['catch'](finish);
        return;
      }
      var line = lines[i];
      i += 1;
      var props = line.properties || {};
      props[PROPERTY_NAME] = value;
      postJson('/cart/change.js', { id: line.id, quantity: line.quantity, properties: props })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/change ' + res.status);
          next();
        })['catch'](fail);
    }

    next();
  }

  /* -------------------------------------------------------------------- Setup */

  /* Klick auf einen gesperrten Button landet mangels pointer-events auf der
     umgebenden Zone. Nur reagieren, wenn das Ereignis die Zone selbst trifft. */
  function onZoneClick(ev) {
    var zone = ev.currentTarget;
    if (ev.target !== zone) return;
    var root = (zone.closest && zone.closest('form')) || document;
    var gate = root.querySelector('[data-tp-pv-gate]') || document.querySelector('[data-tp-pv-gate]');
    if (!gate || isConsented(gate)) return;
    ev.preventDefault();
    shake(gate);
  }

  function bindZones(root) {
    var els = root.querySelectorAll('[data-tp-pv-locked], [data-tp-pv-express]');
    for (var i = 0; i < els.length; i++) {
      var zone = els[i].parentNode;
      if (!zone || zone.nodeType !== 1 || zone.tpPvZoneBound) continue;
      zone.tpPvZoneBound = true;
      zone.addEventListener('click', onZoneClick);
    }
  }

  function bindAll() {
    var gates = document.querySelectorAll('[data-tp-pv-gate]');
    for (var i = 0; i < gates.length; i++) {
      var gate = gates[i];
      if (gate.hasAttribute('data-tp-pv-bound')) continue;
      gate.setAttribute('data-tp-pv-bound', '');
      bindZones((gate.closest && gate.closest('form')) || document);
    }
  }

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-tp-pv-consent')) return;
    var gate = t.closest ? t.closest('[data-tp-pv-gate]') : null;
    if (!gate) return;

    if (mode(gate) === 'cart') {
      if (t.checked) submitCart(gate);
      return;
    }
    applyProduct(gate);
  });

  /* Capture-Phase: greift vor dem submit-Handler von product-form.js — auch dann,
     wenn ein Re-Render den Button zwischenzeitlich wieder aktiviert hat. */
  document.addEventListener(
    'submit',
    function (ev) {
      var form = ev.target;
      if (!form || !form.querySelectorAll) return;
      var gates = form.querySelectorAll('[data-tp-pv-gate]');
      for (var i = 0; i < gates.length; i++) {
        var gate = gates[i];

        if (!isConsented(gate)) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          shake(gate);
          return;
        }

        /* Bestätigt, aber das Cart-Attribut ist noch unterwegs: einmal kurz
           zurückhalten und nach der Antwort (spätestens nach dem Timeout) selbst
           erneut absenden. */
        if (gate.tpPvAttrPending && !gate.tpPvResubmit) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          gate.tpPvResubmit = form;
          return;
        }
      }
    },
    true
  );

  /* Der Cart-Drawer rendert seinen Inhalt bei jedem Add neu — dann hängen die
     Klick-Zonen an toten Nodes. Beobachtet wird nur der Drawer (stabiler Knoten,
     data-skip-node-update), nicht das ganze Dokument. */
  function observeDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;
    var t = null;
    new MutationObserver(function () {
      if (t) clearTimeout(t);
      t = setTimeout(bindAll, 150);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    bindAll();
    observeDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
